import { formatDatePlus } from "../helpers/Utils";

const labelTranslates = {
  supplier_name_eq: "Padalinys",
  asset_cont_any: "File",
  status_i_cont_any: "Status",
  created_at: "Date",
  user_firstname_or_user_lastname_cont: "Uplader",
  title_cont: "Title",
  attrs_raw_cont: "Supplier or Supplier code",
  title_cont: "First or last name",
  email_i_cont_any: "Email",
  product_identifier_cont: "SKU",
  product_title_cont: "Prekė",
  order_id_order_eq: "Order no",
  order_customer_firstname_or_order_customer_lastname_or_order_customer_email_or_order_customer_company_code_cont_any:
    "Client",
  order_rows_product_name_or_order_rows_product_reference_or_order_rows_product_upc_cont:
    "Goods",
  order_carrier_name_in: "Delivery",
  status_eq: "Status",
  return_type_eq: "Return type",
  supplier_id_eq: "Documents",
  order_comments_body_cont: "Comments",
  logistic_comments_body_cont: "Logistic Comments",
  import_errors_null: "Has errors",
};

const generateParams = (filters = {}) => {
  let filtStr = Object.entries(filters)
    .filter(([key, value]) => {
      if (!value && value !== false) return false; // Allow false values

      if (key === "created_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.length > 0;
      }

      if (typeof value === "string") {
        value = value.trim();
        return value.length > 0;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return true; // Allow all other types including boolean
    })
    .map(([key, value]) => {
      if (key === "created_at") {
        const [startDate, endDate] = value;
        const filters = [];

        if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
        if (endDate) filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

        return filters.join("&");
      }

      if (key.includes("_in")) {
        const filters = [];
        value.forEach((item) => {
          filters.push(`q[${key}][]=${item}`);
        });
        return filters.join("&");
      }

      if (key === "import_errors_null") {
        return `q[${key}]=${value}`;
      }

      return `q[${key}]=${value}`;
    })
    .join("&");

  if (filtStr !== "") {
    filtStr = "&" + filtStr;
  }

  return filtStr;
};

export { labelTranslates, generateParams };
